export const InstallerLicenceType = {
    Electrician: 'electricianLicence',
    Plumber: 'plumberLicence'
} as const;

export type InstallerLicenceType = typeof InstallerLicenceType[keyof typeof InstallerLicenceType];
